module.exports = __webpack_public_path__ + "img/coverage.9866dbe.webp";